import React, { Component } from "react";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import Loader from "react-loader-spinner";
import GetDomains from "../../GetDomains";
import { Multiselect } from "multiselect-react-dropdown";

class SupportTeam extends Component {
  constructor() {
    super();

    this.dialogClose = () => {
      this.setState({
        hideupdateDialog: false,
        hideAddDialog: false,
        hideDeletePopup: false,
      });
    };

    this.settings = { effect: "Zoom", duration: 400, delay: 0 };

    //for delete dialog component ok click
    this.buttons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.deleteSupportTeamApi(this.state.propsId);
          this.setState({ disabled: false });
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({ hideDeletePopup: false, disabled: false });
        },
      },
    ];

    this.state = {
      data: [],
      options: [],
      disabled: false,
      emails: [],
      editedId: "-1",
      editImageSrc: "./assets/images/edit.svg",
      contentEditable: "false",
      showStore: false,
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      pageNum: null,
      disableSave: false,
      disableAdd: false,
      domainName: "",
    };
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.approvedImageSrc = "./assets/images/approved.png";
    this.notApprovedImgSrc = "./assets/images/not_approved.png";
    this.domainList = [];
  }
  notifyFailToCreate() {
    toast.dismiss();
    toast(
      <b style={{ color: "red" }}>Oops! Error occurred. \n Please try again</b>,
      {
        position: "top-center",
        color: "red",
      }
    );
  }
  addRow = () => {
    var teamController = this;
    if (teamController.state.pageNum != 0) {
      teamController.setState({ pageNum: 0 });
    }
    var { data } = this.state;
    var newData = [{ id: "", userEmail: "", languageList: [] }, ...data];
    console.log("After adding a new row: ", newData);
    this.setState({ data: newData, contentEditable: true, disabled: true });
  };

  saveSupportTeamApi(props, e) {
    props.original.userEmail = document.getElementById(
      "userEmail" + props.index
    ).innerText;
    props.original.domain = document.getElementById(
      "domain" + props.index
    ).value;
    // if (props.original.domain == "Select Domain") {
    //   this.notifyWarning("Please Select a Domain!");
    //   return;
    // }
    console.log("Language List: ", props.original.languageList);
    if (
      !props.original.languageList ||
      props.original.languageList.length === 0
    ) {
      this.notifyWarning("Please Select one or more languages!");
      return;
    }
    this.state.editedId = "-1";

    this.setState(this.state);
    var validateResult = this.validateCells(props.original.userEmail);
    if (validateResult == true) {
      var updatedData = {};
      if (props.original.domain != "Select Domain") {
        updatedData = {
          emailId: props.original.userEmail,
          projectId: localStorage.getItem("currentProjectId"),
          userRole: "PROJECT_SUPPORT_USER",
          domainId: props.original.domain,
          languageList: props.original.languageList,
        };
      } else {
        updatedData = {
          emailId: props.original.userEmail,
          projectId: localStorage.getItem("currentProjectId"),
          userRole: "PROJECT_SUPPORT_USER",
          languageList: props.original.languageList,
        };
      }
      var addTeamController = this;

      // Convert the data object to a URL-encoded string
      var urlEncodedData = new URLSearchParams();
      Object.keys(updatedData).forEach((key) => {
        if (Array.isArray(updatedData[key])) {
          updatedData[key].forEach((item) => {
            urlEncodedData.append(key, item);
          });
        } else {
          urlEncodedData.append(key, updatedData[key]);
        }
      });

      $.ajax({
        url: "/api/project-membership-by-email",
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: urlEncodedData.toString(),
        success: function (res) {
          if (res.success === true) {
            if (res.result == "done.") {
              addTeamController.notifyAdded();
              addTeamController.fetchSupportTeamDataApi();
              addTeamController.setState({ disabled: false });
            } else {
              addTeamController.notifyAddedData(res.result);
              addTeamController.fetchSupportTeamDataApi();
              addTeamController.setState({ disabled: false });
            }
          } else {
            if (res.result == null) {
              addTeamController.notifyFailedToAdd();
              addTeamController.setState({ disabled: false });
            } else {
              addTeamController.notifyWarning(res.result);
              addTeamController.setState({ disabled: false });
            }
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        },
      });
    }
  }
  notifyAddedData(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
    });
  }

  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  notifyFailedResponseForAdd(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }
  notifyFailedToAdd() {
    toast.dismiss();
    toast(<b>Oops! failed to add member</b>, {
      position: "top-center",
      color: "red",
    });
  }
  updateSupportTeamApi(props, e) {
    props.original.domainId = document.getElementById(
      "domain" + props.index
    ).value;
    if (props.original.domainId == "Select Domain") {
      this.notifyWarning("Please Select a Domain!");
      return;
    }

    if ( !props.original.languageList || props.original.languageList.length === 0 ) {
      this.notifyWarning("Please Select one or more languages!");
      return;
    }

    var validateResult = this.validateCells(props.original.userEmail);
    if (validateResult == true) {
      var updatedData = {};
      if (props.original.domainId != "Select Domain") {
        updatedData = {
          id: props.original.id,
          userEmail: props.original.userEmail,
          projectId: localStorage.getItem("currentProjectId"),
          role: "PROJECT_SUPPORT_USER",
          domainId: props.original.domainId,
          userId: props.original.userId,
          languageList: props.original.languageList,
        };
      } else {
        updatedData = {
          id: props.original.id,
          userEmail: props.original.userEmail,
          projectId: localStorage.getItem("currentProjectId"),
          role: "PROJECT_SUPPORT_USER",
          userId: props.original.userId,
          languageList: props.original.languageList,
        };
      }
      var updatedDataController = this;
      $.ajax({
        url: "/api/project-membership",
        async: false,
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(updatedData),
        success: function (res) {
          if (res.success === true) {
            updatedDataController.notifyUpdate();
            updatedDataController.fetchSupportTeamDataApi();
            updatedDataController.setState({
              editedId: -1,
            });
          } else {
            if (res.result == null) {
              updatedDataController.notifyFailedToUpdate();
              updatedDataController.setState({
                editedId: -1,
              });
            } else {
              updatedDataController.notifyFailedResponse(res.result);
              updatedDataController.setState({ editedId: -1 });
            }
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        },
      });
    }
  }

  notifyFailedToUpdate() {
    toast.dismiss();
    toast(<b>Oops! failed to update</b>, {
      position: "top-center",
      color: "red",
    });
  }

  makeCelledit(props, e) {
    this.markAsBeingEdited(this.state.data[props.index].id, props);
  }

  markAsBeingEdited(id, props) {
    this.state.editedId = id;
    this.state.disableSave = false;
    var stateObj = this.state;
    this.setState(stateObj);
  }
  deleteSupportTeamApi = (id) => {
    let deleteRowViewController = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({
        hideDeleteSuccessPopup: true,
        disabled: false,
      });
      deleteRowViewController.splice(id, 1);
    } else {
      $.ajax({
        url: "/api/project-membership/" + id,
        async: false,
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({
              hideDeletePopup: false,
              disabled: false,
            });
            deleteConstructorVariables.notifyDelete();
            deleteConstructorVariables.fetchSupportTeamDataApi();
          } else {
            deleteConstructorVariables.setState({
              hideDeletePopup: false,
              disabled: false,
            });
            deleteConstructorVariables.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        },
      });
    }
  };
  componentDidMount() {
    setTimeout(() => {
      this.fetchDomainsApi();
      this.fetchLanguageApi();
      this.fetchSupportTeamDataApi();
    }, 300);

    var thisController = this;
    document.addEventListener("projectChanged", function (event) {
      thisController.state.disabled = false;
      thisController.projectId = event.projectId;
      thisController.fetchDomainsApi();
      thisController.fetchSupportTeamDataApi(event.projectId);
    });
  }

  validateCells(userEmail) {
    var pattern = new RegExp(
      /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/
    );
    if (userEmail == "") {
      this.notifyEmptyFields();
      return false;
    } else if (!pattern.test(userEmail)) {
      this.notifyWarning("Please enter valid Email ID");
    } else {
      return true;
    }
  }

  notifyEmptyFields = () => {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill user email field
      </b>,
      {
        position: "top-center",
      }
    );
  };

  notifyWarning(message) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;{message}
      </b>,
      {
        position: "top-center",
      }
    );
  }

  refreshData = (id) => {
    var refreshContent = this;
    refreshContent = this.state.editedId = id;
    this.fetchSupportTeamDataApi();
    this.fetchLanguageApi();
    this.setState({ disabled: false });
  };

  fetchDomainsApi = () => {
    var domains = GetDomains();
    this.domainList = [];
    for (var i = 0; i < domains.length; i++) {
      this.domainList.push({
        domain: domains[i]["domain"],
        domainId: domains[i]["domainId"],
      });
    }
    this.setState(this.state);
  };

  handleLanguageChange = (selectedList, selectedItem, row) => {
    console.log("Row: ", row);

    row.original.userEmail = document.getElementById(
      "userEmail" + row.index
    ).innerText;
    const { data } = this.state;
    const updatedData = data.map((member) => {
      if (member.id === row.original.id) {
        if (!member.languageList) {
          member.languageList = [];
        }
        return {
          ...member,
          languageList: selectedList.map((item) => item.value),
          selectedLanguages: selectedList,
        };
      } else {
        return member;
      }
    });
    this.setState({ data: updatedData });
  };

  fetchSupportTeamDataApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var teamController = this;
    $.ajax({
      url: "/api/project-membership-support-team",
      async: false,
      method: "GET",
      data: {
        projectId: projectId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        teamController.state.successResp = true;
        teamController.setState(teamController.state);
        if (res.success === true) {
          var data = res.result;

          for (const member of data) {
            const { languageList } = member;
            if (languageList) {
              const selectedLanguages = [];
              for (const language of languageList) {
                selectedLanguages.push({ label: language, value: language });
              }
              member["selectedLanguages"] = selectedLanguages;
            }
          }
          teamController.setState({
            data: data,
            disabled: false,
          });

          var disableSave = true;
          for (var i = 0; i < res.result.length; i++) {
            if (
              res.result[i].role == "PROJECT_ADMIN" &&
              res.result[i].userEmail ==
                JSON.parse(localStorage.getItem("user_details"))["emailId"]
            ) {
              disableSave = false;
            }
          }
          if (disableSave) {
            teamController.state.disableSave = true;
            teamController.state.disableAdd = true;
          } else {
            teamController.state.disableSave = false;
            teamController.state.disableAdd = false;
          }
          teamController.setState(teamController);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      },
    });
  };

  fetchLanguageApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var thisController = this;

    $.ajax({
      //url: "/api/asr-api-languages",
      url: "/api/project-languages",
      async: false,
      method: "GET",
      data: { projectId: projectId },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          var languages = res.result.languages;
          const options = [];
          for (var i = 0; i < languages.length; i++) {
            if (languages[i].checked === true ) {
              options.push({
                label: languages[i].language,
                value: languages[i].language,
              });
            }
          }
          thisController.setState({ options });
        } else {
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      },
    });
  };
  handleEmailChange = (e) => {
    this.cursor = e.target.selectionStart;
    this.setState({ selectValue: e.target.value });
  };
  notifyAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Added Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyUpdate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Updated Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyUpdateNotPossible(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }
  notifyDelete() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Deleted Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  onPageChange = (e) => {
    this.setState({ pageNum: e });
  };
  handleChangeDomain = (props, e) => {
    props.original.domainId = e.target.value;
    props.original.userEmail = document.getElementById(
      "userEmail" + props.index
    ).innerText;
    this.setState(this.state);
  };
  render() {
    const { data } = this.state;
    const projectRole = localStorage.getItem("PROJECT_ROLE");
    const isProjectAdmin = projectRole === "PROJECT_ADMIN";

    this.columns = [
      {
        Header: () => <b>User Email</b>,
        accessor: "userEmail",
        sortable: false,
        headerStyle: { marginLeft: "10px" },
        Cell: (props) => (
          <div name="userEmail">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "5%",
                resize: "none",
                borderBottom: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                border:
                  props.original.id == this.state.editedId ||
                  props.original.id == ""
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius:
                  props.original.id == this.state.editedId ||
                  props.original.id == ""
                    ? "2px"
                    : "none",
              }}
              id={"userEmail" + props.index}
              class="form-control"
              rows="1"
              suppressContentEditableWarning
              contentEditable={
                !(props.original.id == ""
                  ? false
                  : props.original.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {props.original.userEmail}
            </div>
          </div>
        ),
      },

      {
        Header: <b>Domain</b>,
        textAlign: "screenLeft",
        accessor: "role",
        sortable: false,
        headerStyle: { marginLeft: "10px" },
        Cell: (props) => {
          return (
            <div
              className="container-fluid"
              style={{ textAlign: "center", marginLeft: "40px" }}
            >
              <select
                className="input-group form-control select2 "
                name="domain"
                style={{
                  marginLeft: "-12%",
                  background: "white",
                  border: "none",
                  width: "60%",
                }}
                id={"domain" + props.index}
                value={
                  props.original.domainId == null ? "" : props.original.domainId
                }
                onChange={(e) => this.handleChangeDomain(props, e)}
                disabled={
                  props.original.id != ""
                    ? props.original.id != this.state.editedId
                    : false
                }
              >
                <option>Select Domain</option>
                {this.domainList.map((domain) => (
                  <option key={domain.domainId} value={domain.domainId}>
                    {domain.domain}
                  </option>
                ))}
              </select>
            </div>
          );
        },
      },
      {
        Header: <b>Languages</b>,
        textAlign: "screenLeft",
        accessor: "languageList",
        headerStyle: { marginLeft: "10px", width: "24vw" },
        Cell: (row) => (
          <div
            name="name"
            className="container-fluid"
            style={{ flexWrap: "wrap" }}
          >
            <div
              style={{
                display:
                  row.original.id === ""
                    ? "none"
                    : row.original.id === this.state.editedId
                    ? "none"
                    : "block",
              }}
              id="appearance-for-selected-days"
            >
              {row.original.languageList &&
                row.original.languageList.map((language, i) => (
                  <span key={language + i}>
                    <button
                      disabled={true}
                      style={{
                        display: "inline",
                        margin: "3px",
                        fontSize: "12px",
                        backgroundColor: "#282a65",
                        padding: "5px 10px",
                        color: "#fff",
                        fontWeight: "500",
                        borderRadius: "5px",
                      }}
                      className="reminderBubble"
                    >
                      {language}
                    </button>
                  </span>
                ))}
            </div>
            <div
              style={{
                display:
                  row.original.id === "" ||
                  row.original.id === this.state.editedId
                    ? "block"
                    : "none",
              }}
            >
              <Multiselect
                options={this.state.options}
                displayValue="label"
                selectedValues={
                  row.original.selectedLanguages
                    ? row.original.selectedLanguages
                    : []
                }
                closeIcon="cancel"
                placeholder="Select Languages"
                className="multiSelectContainer"
                onSelect={(selectedList, selectedItem) =>
                  this.handleLanguageChange(selectedList, selectedItem, row)
                }
                onRemove={(selectedList, selectedItem) =>
                  this.handleLanguageChange(selectedList, selectedItem, row)
                }
                disabled={
                  row.original.id === ""
                    ? false
                    : row.original.id !== this.state.editedId
                }
                style={{
                  marginTop: "10px",
                  position: "absolute",
                  zIndex: 9999,
                  width: "100%",
                  left: 0,
                  top: "100%",
                }}
              />
            </div>
          </div>
        ),
      },

      {
        Header: <b>Approved</b>,
        accessor: "approved",
        width: 100,
        sortable: false,
        headerStyle: { textAlign: "center" },
        Cell: (props) => {
          return (
            <div Align="center">
              <img
                className="img-responsive"
                hidden={props.original.id == "" ? true : false}
                src={
                  props.original.approved == true
                    ? this.approvedImageSrc
                    : this.notApprovedImgSrc
                }
              />
            </div>
          );
        },
      },

      {
        Header: <b>Action</b>,
        accessor: "action",
        filterable: false,
        flexGrow: 1,
        width: 100,
        sortable: false,
        headerStyle: { textAlign: "center" },
        Cell: (props) => (
          <div id="action" style={{ marginLeft: "20px" }}>
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginTop: "-10px",
                marginLeft: "-12px",
                opacity: !isProjectAdmin ? 0.65 : 1,
              }}
              disabled={!isProjectAdmin}
              onClick={(e) => {
                props.original.id == ""
                  ? this.saveSupportTeamApi(props, e)
                  : props.original.id == this.state.editedId
                  ? this.updateSupportTeamApi(props, e)
                  : this.makeCelledit(props, e);
              }}
            >
              <img
                className="img-responsive"
                title={
                  props.original.id == "" ||
                  this.state.data[props.index].id == this.state.editedId
                    ? "Save"
                    : "Edit"
                }
                style={{
                  marginTop: "6px",
                  backgroundColor: "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
                src={
                  props.original.id == ""
                    ? this.saveImageSrc
                    : props.original.id != this.state.editedId
                    ? this.editImageSrc
                    : this.saveImageSrc
                }
              />
            </button>

            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginTop: "-10px",
                marginLeft: "0px",
                opacity: !isProjectAdmin ? 0.65 : 1,
              }}
              title="Delete"
              disabled={!isProjectAdmin}
              onClick={() =>
                props.original.id === ""
                  ? this.fetchSupportTeamDataApi()
                  : this.setState({
                      hideDeletePopup: true,
                      deletePropIndex: props.index,
                      propsId: props.original.id,
                    })
              }
            >
              <img
                className="img-responsive"
                src={"./assets/images/baseline_delete_white_24dp.png"}
                style={{
                  marginTop: "6px",
                  backgroundColor: "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
              />
            </button>
          </div>
        ),
      },
    ];

    return (
      <div>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.successResp ? false : true}
          height={300}
          width={50}
          style={{ textAlign: "center" }}
        />
        <div
          style={{
            background: "#F9F9FB",
            display: this.state.successResp ? "block" : "none",
          }}
        >
          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          {/* for reactTable */}
          <link
            rel="stylesheet"
            href="assets/css/React_Table_CSS/react-table.css"
          />
          {/*links for css files used for popup */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          {/* <link rel="stylesheet" href="./assets/css/react-table-height.css" /> */}
          <div className="wrapper" style={{ marginTop: "-20px" }}>
            <div
              className="row"
              style={{ marginLeft: "2px", marginTop: "-15px" }}
            >
              <div className="col-sm-5">
                <h6
                  className="nav-item"
                  style={{ color: "#282a65", marginTop: "35px" }}
                >
                  Support Team
                </h6>
              </div>
              {/* Add button */}
              <div className="col-sm-7 p-0">
                <div className="d-flex flex-row-reverse pt-2">
                  <div className="p-2">
                    <button
                      className="btn action-button"
                      title="Add"
                      id="addMsg"
                      disabled={!isProjectAdmin}
                      style={{ opacity: !isProjectAdmin ? 0.65 : 1 }}
                      onClick={
                        this.state.disabled
                          ? this.notifyEmptyFields
                          : this.addRow.bind(this)
                      }
                    >
                      <img src="./assets/images/add_white_24dp.png" />
                    </button>
                    <button
                      className="btn action-button"
                      onClick={this.refreshData}
                      type="button"
                      title="Refresh"
                    >
                      <img src="./assets/images/refresh_white_24dp.png"></img>
                    </button>
                    <div className="container-fluid">
                      <div className="card-body p-0">
                        <div className="card-body p-0">
                          <div
                            id="example2_wrapper"
                            className="dataTables_wrapper container-fluid dt-bootstrap4 p-0"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* left Menu start here*/}
            {/* Content Header (Page header) */}
            {/* /.content-header */}
            {/* Custom Tabs */}
            <div className="content">
              <div className="container-fluid">
                <div className="row" style={{ marginTop: "1%" }}>
                  <div className="col-lg-12 ">
                    <div className="card">
                      <ReactTable
                        data={data}
                        columns={this.columns}
                        defaultPageSize={10}
                        pageSizeOptions={[5, 10, 15]}
                        onPageChange={this.onPageChange}
                        page={this.state.pageNum}
                      />
                    </div>
                    <ToastContainer className="Toast-at-center" />
                    {/*Dialog Component For Deletion Confirmation*/}
                    <DialogComponent
                      width="400px"
                      animationSettings={this.settings}
                      header="Delete Confirmation"
                      showCloseIcon={true}
                      buttons={this.buttons}
                      ref={(dialog) => (this.dialogInstance = dialog)}
                      visible={this.state.hideDeletePopup}
                      close={this.dialogClose}
                    >
                      <img
                        src="assets/images/warn.svg"
                        style={{
                          paddingRight: "0px",
                          height: "20px",
                          width: "20px",
                        }}
                        content=""
                      />
                      &nbsp;Do you want to delete the user ?<br />
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note:
                      Press 'Yes' to delete or press 'No' to decline.
                    </DialogComponent>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SupportTeam;



// WEBPACK FOOTER //
// ./src/projectmgmt/settings/team/SupportTeam.js